import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent,fetchData } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize, getValidationsResult, cleanupString } from '../../utils'
import {FetchPromoCode} from '../../state/api'
import moment from 'moment'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import NumberFormat from 'react-number-format';
import MobileDetect from 'mobile-detect'
class Textbox extends Component {
  constructor(props) {
    super(props)

    moment.locale('it')

    this.state = {
      value: props.component.value || ''
    }
  }

  componentDidMount() {
    if (
      !!this.props.component.value &&
      this.props.component.hasOwnProperty('validations') &&
      this.props.component.validations.hasOwnProperty('url')
    ) {
      const { component, dispatch } = this.props
      dispatch(updateComponent(component.id, { value: component.value }))
    }
    if(this.props.component.name==="PromoCode")
    {
      const { component, dispatch } = this.props
      let body=component.fetchPromoCode.body
      let url=component.fetchPromoCode.url
      FetchPromoCode(url,body).then(json=>{
        component.value=(!!json.payLoad && json.payLoad.PromoCode)? json.payLoad.PromoCode:""//"PRMDOO2"
        //(!!component.value)?dispatch(updateComponent(component.id, { value: component.value,isDisabled:true})):
        // if(!!component.value)
        // {
        //   dispatch(updateComponent(component.id, { value: component.value,isDisabled:true}))
        // }
        // else
        // {
        dispatch(updateComponent(component.id, { value: component.value}))
        //}
      })
    }
    if(this.props.component.id=== "S1-S1S1D1" && this.props.component.cleanName === "Insegna")
    {
      const { component, dispatch } = this.props
       if(!!component.value)
         {
          //let companyname="SLR";
          let companyname=component.value.replace(/[^a-zA-Z ]/g, "")
          dispatch(updateComponent(component.id, { value: companyname}))
        }
      
    }

    
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.component && nextProps.component.value !== this.state.value) {
      this.setState({
        value: nextProps.component.value
      })
    }
  }
urlParam(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    }
    else {
       return decodeURI(results[1]) || 0;
    }
}
  handleChange(e) {
    const queryPlanParam=this.urlParam('plan');
    if(this.props.component.id=== "S1-S1S1D1" && this.props.component.cleanName === "Insegna")
    {
      e.target.value=e.target.value.replace(/[^a-zA-Z ]/g, "")
    }
    else if((!!queryPlanParam && queryPlanParam.toLowerCase()==='flexmini') &&  this.props.component.id==='S2-S2S1D1' && this.props.component.cleanName === 'Numero Terminali POS da Installare' && !(/^\d$/.test(e.target.value) && parseInt(e.target.value) <= 5))
    {
          e.target.value=''
    }
    const val = e.target.value
    const { component, dispatch } = this.props

    if (this.props.type === 'date') {
      dispatch(
        updateComponent(component.id, {
          value: moment(val).format('DD/MM/YYYY')
        })
      )
      e.preventDefault()
    } else {
      
      // this.setState({value:val});
      this.setState({ value: val }, () => {
        dispatch(updateComponent(component.id, { value: val}))
      })
    }
  }

  validateRequired() {
    const { component } = this.props
    if (
      component.validations &&
      component.validations.isRequired &&
      !component.isDisabled
    ) {
      return true
    }
    return false
  }

  onFocus(e) {
    const { dispatch, component } = this.props
    if (e.target.type === 'text') {
      const inputs = Array.prototype.slice.call(
        document.querySelectorAll(`[name="${component.id}"]`)
      )
      const dateInput = inputs.find(t => t.type === 'date')
      if (!!dateInput) {
        dispatch(updateComponent(component.id, { isPickerVisible: true }))
        setTimeout(() => {
          dateInput.focus()
          dateInput.click()
        }, 100)
      } else {
        if (!!component.hint) {
          dispatch(
            updateComponent(
              component.id,
              {
                hint: { ...component.hint, visible: true },
                errorMessage:'',
                status:[]
              },
              { avoidValidation: true }
            )
          )
        }
      }
    }
  }

  onBlur(e) {
    const { dispatch, component } = this.props
    const delta = {}
    if (e.target.type === 'date' && e.target.value === '') {
      delta.isPickerVisible = false
    } else if (e.target.type === 'text') {
      //const cleanValue = cleanupString(e.target.value)
      delta.value = cleanupString(e.target.value)
      // if (cleanValue !== component.value) {
      //   delta.value = cleanupString(component.value)
      // }
      
      if (!!component.hint) {
        delta.hint = { ...component.hint, visible: false }
      }
    }
    if (Object.keys(delta).length > 0) {
      component.value=delta.value
      dispatch(updateComponent(component.id, delta))
    }
  }
//   toggle_visibility(id) {
//     var divElemIBANText =document.getElementById(id);
//     var label = document.getElementById("divIBANQuestion");
 
//     if(divElemIBANText.style.display == 'none' || divElemIBANText.style.display == '')
//      {
//        label.innerHTML = label.innerHTML.replace("[+]","[-]");
//        divElemIBANText.style.display = 'block';
//      }
//     else
//     {
//        label.innerHTML = label.innerHTML.replace("[-]","[+]");
//        divElemIBANText.style.display = 'none';
 
//     }
//  }
  getProperErrorMessage() {
    const { component } = this.props

    if (!!component.validations.overrides) {
      const validationResult = getValidationsResult({
        component,
        type: 'overrides'
      })
      if (!validationResult.result) {
        return validationResult.errorMessage
      }
    }
    return component.errorMessage && component.errorMessage[0]
  }
  renderStaticTextPhoneNum(){
  return 'Cliccando su ‘Invia il codice di verifica’ riceverai un SMS con il codice OTP'//'Inserisci il tuo numero di cellulare per ricevere via SMS il codice di sicurezza OTP'
  }
  renderStaticTextUnderOTP(){

    return 'Inserisci il codice di verifica OTP ricevuto sul tuo numero di cellulare'
  }
  renderStaticTextDenominazione(){
   return 'Attenzione: nel caso in cui tu sia un libero professionista ti chiediamo di indicare come ragione sociale solamente il tuo nome e il tuo cognome.'
  }
  renderStaticTextPuntoVendita(){
    return `Per visualizzare correttamente il nome della tua insegna sullo scontrino ti suggeriamo di non utilizzare i caratteri speciali (inclusi accenti e apostrofi). Ti consigliamo di sostituirli con caratteri normali.`
  }
  renderStaticTextPuntoVendita1(){
    return `«Questo nome comparirà sulla copia della transazione che stamperà il tuo POS Easy. Il numero massimo di caratteri che puoi inserire è di XX. Puoi inserire solo lettere o numeri, non puoi utilizzare segni di punteggiatura o caratteri speciali»`
  }
  renderStaticTextPuntoVendita2(){
    return `In caso di inserimento caratteri non consentiti, controllo immediato e deve comparire la scritta.`
  }
  renderStaticTextPuntoVendita3(){
    return `«Testo non valido, ricordati di inserire solo lettere o numeri!» in rosso`
  }
  render() {
    const { widget, component} = this.props
    const md = new MobileDetect(window.navigator.userAgent)
    const queryPlanParam=this.urlParam('plan');
    if(component.id==="S2-S2S1D1" && !!queryPlanParam && queryPlanParam.toLowerCase()==='flexmini')
    {
      component.maxLength='1'
    }
    // component.cleanName = (component.id === "S1-S1S1D1" && component.cleanName === "Insegna") ? "Nome attività" : component.cleanName
    return (
      <div
        {...css(
          this.props.styles.component,
          component.fullWidth && this.props.styles.singleField,
          ((this.props.type === 'date' && !component.isPickerVisible) ||
            (this.props.type === 'text' && !!component.isPickerVisible)) &&
            this.props.styles['component--hidden'],
            component.id==='CELLULARE-NUM_CELLULARE' && 
              this.props.styles.divAlignPhoneNum,
          component.id==='CELLULARE-CODICE_CELLULARE' && !md.mobile() && this.props.styles.otpWidth,
          component.id == 'S1-S1S1D1' && this.props.styles.fullFieldWidth,
          component.id==='PROMO-PromoCode' && this.props.styles.grayed
        )}
      >
      {component.componentTitle && <b {...css(this.props.styles.componentTitle)}>{component.componentTitle}</b>}
      {!!component.numFormat && component.numFormat==='Europian'?
      <NumberFormat
      allowNegative={component.id==="CLASSIFICAZIONE_AZIENDA-RISULTATO_ECONOMICO"}
      displayType={this.props.component.displayType}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={'€ '} 
      fixedDecimalScale={false} decimalScale={2}
      placeholder={component.cleanName}
      value={this.state.value}
      onFocus={this.onFocus.bind(this)}
      onBlur={this.onBlur.bind(this)}
      onChange={this.handleChange.bind(this)}
      {...css(
        this.props.styles.input,
        // component.status.indexOf('error') <= -1 && component.value!=='' &&
        // this.props.styles['input--valid'],
        component.status.indexOf('error') > -1 &&
          this.props.styles['input--invalid'],
        component.status.indexOf('loading') > -1 &&
          this.props.styles['input--blink']
      )}
      name={component.id}
      />:
        <input
          type={this.props.type}
          placeholder={component.cleanName}
          value={
            this.props.type === 'date' && !!this.state.value
              ? moment(this.state.value, 'DD/MM/YYYY').format('YYYY-MM-DD')
              : this.state.value
          }
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onChange={this.handleChange.bind(this)}
          {...css(
            this.props.styles.input,
            // component.status.indexOf('error') <= -1 && component.value!=='' &&
            // this.props.styles['input--valid'],
            component.status.indexOf('error') > -1 &&
              this.props.styles['input--invalid'],
            component.status.indexOf('loading') > -1 &&
              this.props.styles['input--blink'],
            component.id==='PROMO-PromoCode' &&
              this.props.styles.grayedText
          )}
          disabled={
            !!component.isDisabled ||
            component.status.indexOf('readonly') > -1 ||
            widget.status.indexOf('readonly') > -1
          }
          readOnly={component.type === 'date' && this.props.type === 'text'}
          name={component.id}
          maxLength={component.maxLength}
        />
        }
         {/* {component.id==='CELLULARE-NUM_CELLULARE' && component.status.indexOf('error') <= -1 && component.value!==''? <span {...css(this.props.styles.checkmark)}>
          <div {...css(this.props.styles.checkmarkCircle)}></div>
          <div {...css(this.props.styles.checkmarkStem)}></div>
          <div {...css(this.props.styles.checkmarkKick)}></div>
          </span>:''} */}
        {/* <span>{component.id==='CELLULARE-CODICE_CELLULARE' && !component.isDisabled ?component.validMessage:''}</span> */}
        {/* <span>{component.id==='CELLULARE-NUM_CELLULARE'?this.renderStaticTextPhoneNum():''}</span> */}
        {/* {component.id==="S4-S4S1D1" && component.cleanName==="IBAN" ?<span {...css(this.props.styles.ibantextfont)}><a href="javascript:void(0)"  onClick={this.toggle_visibility.bind(this,"divIBANText")} ><div id="divIBANQuestion">Vuoi inserire un IBAN Estero? [+]  </div>
        </a><div id="divIBANText" {...css(this.props.styles.gap)}>Se hai anche un IBAN italiano, puoi inserirlo per concludere la richiesta in autonomia. Una volta conclusa, potrai comunicarci le coordinate bancarie corrette, seguendo le istruzioni di questa <a href="https://www.axerve.com/assistenza/soluzioni-punto-vendita/pos-easy/modificare-coordinate-conto-di-accredito-e-addebito-pos-easy" target="_blank">FAQ</a>. Se non hai un IBAN italiano, contatta la nostra <a href="https://www.axerve.com/assistenza/assistenza-tecnica" target="_blank">assistenza</a> per approfondire come procedere.</div></span>:''} */}
        <span>{component.id==='CELLULARE-CODICE_CELLULARE'?this.renderStaticTextUnderOTP():''}</span>
        <span><small><b>{component.id==='S1-S1S1D1'?this.renderStaticTextPuntoVendita():''}</b></small></span>
        {/*<span>{component.id==='S1-S1S1D1' && (<small>
          <b>{this.renderStaticTextPuntoVendita1()}</b><br/><br/>
          <b>{this.renderStaticTextPuntoVendita2()}</b><br/><br/>
          <b>{this.renderStaticTextPuntoVendita3()}</b>
        </small>)}</span>*/}
        <span>{(component.id==='DENOMINAZIONE_AZIENDA-DENOMINAZIONE' && (!!component.staticDescFlag && component.staticDescFlag===true))?this.renderStaticTextDenominazione():''}</span>
        {component.id!=='PROMO-PromoCode' && <span
          {...css(
            this.props.styles.label,
            this.state.value !== '' && this.props.styles['label--active']
          )}
        >
          {component.cleanName}
        </span>}
        <small {...css(this.props.styles['error-msg'])}>
          {camelize(this.getProperErrorMessage(), true, true)}
        </small>
        {!!component.hint && !!component.hint.visible ? (
          <span {...css(this.props.styles.hint)}>
            {this.props.component.hint.value}
          </span>
        ) : (
          ''
        )}
      </div>
      
    )
  }
}

Textbox.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['text', 'date']),
  styles: PropTypes.object.isRequired
}

Textbox.defaultProps = {
  type: 'text'
}

Textbox.defaultProps = {
  type: 'text'
}

const mapStateToProps = (/*state, ownProps*/) => {
  /*const { components } = state
  return { component: components[ownProps.component.id] }*/
  return {}
}

export default connect(mapStateToProps)(withStyles(Styles)(Textbox))



// WEBPACK FOOTER //
// ./components/textbox/index.js